import arTranslations from '../locales/ar.json';

export const translations = {
  ar: arTranslations,
};

// Helper function to get nested translation keys
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => current?.[key], obj);
};

export const useTranslation = (language = 'ar') => {
  const t = (key, fallback) => {
    // First try legacy translations (flat keys)
    let value = legacyTranslations.ar[key];
    
    // If not found in legacy, try nested translations
    if (value === undefined) {
      value = getNestedValue(translations.ar, key);
    }
    
    // If value is an object (nested structure), try to get .title
    if (value !== undefined && typeof value === 'object' && value.title) {
      value = value.title;
    }
    
    // Return value, fallback, or key
    return (typeof value === 'string') ? value : (fallback || key);
  };

  return { t };
};

// Legacy support - flat translations object
export const legacyTranslations = {
  ar: {
    hesabaty: "Nazario-Hesabaty",
    appName: "Nazario-Hesabaty",
    appSubtitle: "نظام إدارة حسابات المتاجر",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    phone: "رقم الهاتف",
    shopName: "اسم المحل",
    logout: "تسجيل الخروج",
    subscription: "الاشتراك",
    subscriptionPending: "في انتظار تفعيل الاشتراك",
    subscriptionActive: "الاشتراك مفعّل",
    subscriptionExpired: "انتهى الاشتراك",
    dashboard: "لوحة التحكم",
    inventory: "المخزون",
    sales: "المبيعات",
    pos: "نقطة البيع",
    purchases: "المشتريات",
    customers: "الزبائن",
    suppliers: "الموردين",
    employees: "الموظفين",
    reports: "التقارير",
    settings: "الإعدادات",
    damages: "التلفيات",
    expenses: "المصاريف",
    todaySales: "مبيعات اليوم",
    cashSales: "مبيعات نقدية",
    creditSales: "مبيعات آجلة",
    monthlyProfit: "ربح الشهر",
    totalProducts: "إجمالي المنتجات",
    lowStock: "مخزون منخفض",
    customerDebt: "ديون الزبائن",
    supplierDebt: "ديون الموردين",
    products: "المنتجات",
    addProduct: "إضافة منتج",
    editProduct: "تعديل منتج",
    productCode: "كود المنتج",
    productName: "اسم المنتج",
    purchasePrice: "سعر الشراء",
    salePrice: "سعر البيع",
    quantity: "الكمية",
    category: "التصنيف",
    minStock: "الحد الأدنى",
    newSale: "بيع جديد",
    saleDetails: "تفاصيل البيع",
    customer: "الزبون",
    paymentType: "نوع الدفع",
    cash: "نقدي",
    credit: "آجل",
    dueDate: "تاريخ الاستحقاق",
    total: "المجموع",
    amountPaid: "المبلغ المدفوع",
    remaining: "المتبقي",
    newPurchase: "شراء جديد",
    supplier: "المورد",
    addCustomer: "إضافة زبون",
    customerName: "اسم الزبون",
    address: "العنوان",
    debt: "الدين",
    payDebt: "دفع دين",
    addSupplier: "إضافة مورد",
    supplierName: "اسم المورد",
    addEmployee: "إضافة موظف",
    employeeName: "اسم الموظف",
    jobTitle: "الوظيفة",
    salary: "الراتب",
    advances: "السلف",
    paySalary: "دفع راتب",
    payAdvance: "دفع سلفة",
    addDamage: "إضافة تلف",
    damageReason: "سبب التلف",
    value: "القيمة",
    addExpense: "إضافة مصروف",
    expenseType: "نوع المصروف",
    description: "الوصف",
    profitLoss: "الأرباح والخسائر",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    generateReport: "إنشاء التقرير",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    search: "بحث",
    filter: "تصفية",
    all: "الكل",
    actions: "الإجراءات",
    date: "التاريخ",
    amount: "المبلغ",
    notes: "ملاحظات",
    status: "الحالة",
    active: "مفعّل",
    inactive: "غير مفعّل",
    confirm: "تأكيد",
    success: "تم بنجاح",
    error: "حدث خطأ",
    loading: "جاري التحميل...",
    noData: "لا توجد بيانات",
    subscriptionPrice: "سعر الاشتراك",
    currency: "د.ع",
  },
};
